var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.86157 3.72325H11.1949L10.2732 12.0183C10.2416 12.3037 10.1059 12.5675 9.89189 12.7591C9.67791 12.9507 9.40078 13.0566 9.11357 13.0566H3.94291C3.65569 13.0566 3.37857 12.9507 3.16459 12.7591C2.95062 12.5675 2.81483 12.3037 2.78324 12.0183L1.86157 3.72325Z",
    stroke: "#1E293B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.81266 2.05901C3.90702 1.8589 4.05632 1.68975 4.24316 1.57129C4.43 1.45282 4.64668 1.38992 4.86791 1.38992H8.18824C8.40957 1.38981 8.62637 1.45266 8.81333 1.57113C9.00028 1.6896 9.14968 1.85881 9.24408 2.05901L10.0281 3.72326H3.02808L3.81266 2.05901Z",
    stroke: "#1E293B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.694824 3.72325H12.3615",
    stroke: "#1E293B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.36157 6.63992V9.55659",
    stroke: "#1E293B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.69482 6.63992V9.55659",
    stroke: "#1E293B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashBlack);
export default __webpack_public_path__ + "static/media/trashBlack.ec462aae74df10489323e0e23b5ca2ed.svg";
export { ForwardRef as ReactComponent };